export default "__VITE_ASSET__3OrYFLPL__"